export const links = {
  INSTAGRAM: `https://www.instagram.com/rentacar.france/`,
  LINKEDIN: `https://www.linkedin.com/company/rent-a-car/`,
  FACEBOOK: `https://www.facebook.com/rentacar.france`,
  TWITTER: `https://twitter.com/rentacar_france?lang=fr`,
} as const;
